import { useState, useEffect, useCallback } from 'react';
import { userEmailStorageService } from '@/services/userEmailStorageService';

interface UseUserEmailReturn {
  userEmail: string;
  setUserEmail: (email: string) => void;
  clearUserEmail: () => void;
  isStorageAvailable: boolean;
}

export const useUserEmail = (): UseUserEmailReturn => {
  const [userEmail, setUserEmailState] = useState<string>('');

  // Initialize userEmail from storage on mount
  useEffect(() => {
    const storedEmail = userEmailStorageService.getUserEmail();
    if (storedEmail) {
      setUserEmailState(storedEmail);
    }
  }, []);

  // Update userEmail and persist to storage
  const setUserEmail = useCallback((email: string) => {
    setUserEmailState(email);
    
    // Let the storage service handle trimming
    if (email.trim()) {
      userEmailStorageService.setUserEmail(email);
    }
  }, []);

  // Clear userEmail from state and storage
  const clearUserEmail = useCallback(() => {
    setUserEmailState('');
    userEmailStorageService.clearAllData();
  }, []);

  // Check if storage is available
  const isStorageAvailable = userEmailStorageService.isStorageAvailable();

  return {
    userEmail,
    setUserEmail,
    clearUserEmail,
    isStorageAvailable
  };
}; 